export const getControlsWidth = ({ buttonsWidths, containerWidth, isBreakpointMobile, setAreButtonsVerticallyAlign, }) => {
    let buttonsWidth = 0;
    for (const width of buttonsWidths) {
        buttonsWidth += width;
    }
    if (buttonsWidth > containerWidth || isBreakpointMobile) {
        setAreButtonsVerticallyAlign(true);
    }
    else {
        setAreButtonsVerticallyAlign(false);
    }
};
//# sourceMappingURL=getControlsWidth.js.map